import { DEFAULT_LANGUAGE } from 'frontend-container/components/Menu/components/User/UserPreferences/configuration';
import i18n from 'frontend-container/i18n';

export const getConfigurationEntityDescription = (
  descriptionMap: Record<string, string>
): string => {
  return descriptionMap[i18n.language] || descriptionMap[DEFAULT_LANGUAGE];
};
